import React from 'react';
import { UIProperties } from '../UIProperties';

const SampleScenarioUI = (props: UIProperties<SampleScenarioUIConfig>) => {
	return (
		<div style={{pointerEvents: 'all'}}>
			<img style={{
				width: '200px'
			}} src="./assets/images/sample-scenario/uparrow.svg" onClick={props.parameters.onUpArrowClicked}/>
			<img style={{
				width: '200px'
			}} src="./assets/images/sample-scenario/downarrow.svg" onClick={props.parameters.onDownArrowClicked}/>
			<img style={{
				width: '200px'
			}} src="./assets/images/sample-scenario/leftarrow.svg"  onClick={props.parameters.onLeftArrowClicked}/>
			<img style={{
				width: '200px'
			}} src="./assets/images/sample-scenario/rightarrow.svg"  onClick={props.parameters.onRightArrowClicked}/>
			
		</div>
	);

};

export interface SampleScenarioUIConfig {
	onUpArrowClicked: () => void;
	onDownArrowClicked: () => void;
	onLeftArrowClicked: () => void;
	onRightArrowClicked: () => void;
}

export default SampleScenarioUI;